module.exports = __webpack_public_path__ + "img/sheild.ea0d217e.png";